/** 格式化后端返回的时间字符串 */
export const formatDateTime = (value) => {
    if (!value) {
        return '—';
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
        return String(value);
    }
    return d.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
};

/** 格式化文件大小 */
export const formatFileSize = (bytes) => {
    if (bytes == null || bytes === 0) {
        return '—';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let size = Number(bytes);
    let i = 0;
    while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i += 1;
    }
    return `${size.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};

/** macOS AppleDouble 伴生文件（如 ._IMG_1054.PNG），不是可预览的真实图片 */
export const isMacOsSidecarFileName = (fileName) =>
    typeof fileName === 'string' && fileName.startsWith('._');

/** 基金收益率等小数值（后端为比例，如 0.05 表示 5%） */
export const formatReturnRatio = (value, digits = 2) => {
    if (value == null || value === '') {
        return '—';
    }
    const n = Number(value);
    if (Number.isNaN(n)) {
        return '—';
    }
    const pct = n * 100;
    const sign = pct > 0 ? '+' : '';
    return `${sign}${pct.toFixed(digits)}%`;
};

/** 净值等金额 */
export const formatNav = (value, digits = 4) => {
    if (value == null || value === '') {
        return '—';
    }
    const n = Number(value);
    if (Number.isNaN(n)) {
        return '—';
    }
    return n.toFixed(digits);
};
